// constants of the canvas
const $820877bea407f5fe$var$canvasWidth = 800;
const $820877bea407f5fe$var$characterWidth = 36;
const $820877bea407f5fe$export$276ccf0fd889e42 = 16;
const $820877bea407f5fe$export$8d09caa4156ca8c8 = 16;
// drawing
const $820877bea407f5fe$var$canvas = document.getElementById("canvas");
const $820877bea407f5fe$var$ctx = $820877bea407f5fe$var$canvas.getContext("2d");
const $820877bea407f5fe$export$e529deb2bfd496dc = (state)=>{
    $820877bea407f5fe$var$ctx.clearRect(0, 0, $820877bea407f5fe$var$canvasWidth, $820877bea407f5fe$var$canvasWidth / 2);
    $820877bea407f5fe$var$ctx.fillStyle = "black";
    $820877bea407f5fe$var$ctx.fillRect(0, 0, $820877bea407f5fe$var$canvasWidth, $820877bea407f5fe$var$canvasWidth / 2);
    if (state.isGameOver) {
        $820877bea407f5fe$var$ctx.fillStyle = "white";
        $820877bea407f5fe$var$ctx.font = "bold 92px monospace";
        $820877bea407f5fe$var$ctx.textAlign = "center";
        $820877bea407f5fe$var$ctx.fillText(state.text, $820877bea407f5fe$var$canvasWidth / 2, $820877bea407f5fe$var$canvasWidth / 4);
        $820877bea407f5fe$var$ctx.font = "bold 42px monospace";
        $820877bea407f5fe$var$ctx.fillText(`Your score is: ${state.score}`, $820877bea407f5fe$var$canvasWidth / 2, $820877bea407f5fe$var$canvasWidth / 3);
        $820877bea407f5fe$var$ctx.font = "bold 22px monospace";
        $820877bea407f5fe$var$ctx.fillStyle = "#ffff00";
        $820877bea407f5fe$var$ctx.fillText("[press space to continue]", $820877bea407f5fe$var$canvasWidth / 2, $820877bea407f5fe$var$canvasWidth / 2 - 42);
        return;
    }
    $820877bea407f5fe$var$ctx.fillStyle = "white";
    $820877bea407f5fe$var$ctx.font = "bold 92px monospace";
    $820877bea407f5fe$var$ctx.textAlign = "center";
    $820877bea407f5fe$var$ctx.fillText(state.score, $820877bea407f5fe$var$canvasWidth / 2, 118);
    state.dots.forEach((dot)=>{
        if (dot.magic) {
            $820877bea407f5fe$var$ctx.fillStyle = "white";
            if (!dot.eaten) $820877bea407f5fe$var$ctx.fillRect(dot.x, $820877bea407f5fe$var$canvasWidth / 4 + $820877bea407f5fe$export$8d09caa4156ca8c8 / 2, $820877bea407f5fe$export$8d09caa4156ca8c8 * 1.1, $820877bea407f5fe$export$8d09caa4156ca8c8 * 1.1);
        } else {
            $820877bea407f5fe$var$ctx.fillStyle = "#ffb751";
            if (!dot.eaten) $820877bea407f5fe$var$ctx.fillRect(dot.x, $820877bea407f5fe$var$canvasWidth / 4 + $820877bea407f5fe$export$8d09caa4156ca8c8 / 2, $820877bea407f5fe$export$8d09caa4156ca8c8, $820877bea407f5fe$export$8d09caa4156ca8c8);
        }
    });
    $820877bea407f5fe$var$ctx.fillStyle = "#2121ff";
    $820877bea407f5fe$var$ctx.fillRect(0, $820877bea407f5fe$var$canvasWidth / 4 - $820877bea407f5fe$var$characterWidth, $820877bea407f5fe$var$canvasWidth, 5);
    $820877bea407f5fe$var$ctx.fillRect(0, $820877bea407f5fe$var$canvasWidth / 4 - $820877bea407f5fe$var$characterWidth + 15, $820877bea407f5fe$var$canvasWidth, 5);
    $820877bea407f5fe$var$ctx.fillRect(0, $820877bea407f5fe$var$canvasWidth / 4 + $820877bea407f5fe$var$characterWidth + 15, $820877bea407f5fe$var$canvasWidth, 5);
    $820877bea407f5fe$var$ctx.fillRect(0, $820877bea407f5fe$var$canvasWidth / 4 + $820877bea407f5fe$var$characterWidth + 30, $820877bea407f5fe$var$canvasWidth, 5);
    $820877bea407f5fe$var$ctx.fillStyle = "#ffff00";
    $820877bea407f5fe$var$ctx.fillRect(state.playerX, $820877bea407f5fe$var$canvasWidth / 4, $820877bea407f5fe$var$characterWidth, $820877bea407f5fe$var$characterWidth);
    if (state.isMagicOn && !state.isBlinking) $820877bea407f5fe$var$ctx.fillStyle = "#2121ff";
    else if (state.isMagicOn && state.isBlinking) $820877bea407f5fe$var$ctx.fillStyle = "white";
    else $820877bea407f5fe$var$ctx.fillStyle = "#ff0000";
    $820877bea407f5fe$var$ctx.fillRect(state.ghostX, $820877bea407f5fe$var$canvasWidth / 4, $820877bea407f5fe$var$characterWidth, $820877bea407f5fe$var$characterWidth);
};
const $820877bea407f5fe$export$5efe44c485c74673 = (x1, x2, width1 = $820877bea407f5fe$var$characterWidth, width2 = width1)=>{
    return x1 + width1 >= x2 && x1 <= x2 + width2;
};
const $820877bea407f5fe$export$400968b3f7ddc0a8 = (x, movingRight, playerSpeed)=>{
    if (movingRight) return (x + playerSpeed) % $820877bea407f5fe$var$canvasWidth;
    else if (x - playerSpeed < -$820877bea407f5fe$var$characterWidth) return $820877bea407f5fe$var$canvasWidth;
    else return x - playerSpeed;
};
const $820877bea407f5fe$export$5eb9f060287f3708 = (currentX, playerX, magicOn, ghostSpeed, randomValue)=>{
    if (magicOn && $820877bea407f5fe$export$5efe44c485c74673(currentX, playerX)) return randomValue < 0.5 ? 0 - $820877bea407f5fe$var$characterWidth * 7 : $820877bea407f5fe$var$canvasWidth + $820877bea407f5fe$var$characterWidth * 7;
    if (playerX > currentX) {
        if (magicOn && 0 < currentX) return currentX - ghostSpeed * 0.5 < 0 ? 0 : currentX - ghostSpeed * 0.5;
        return currentX + ghostSpeed;
    } else {
        if (magicOn && currentX < $820877bea407f5fe$var$canvasWidth - $820877bea407f5fe$var$characterWidth) return currentX + ghostSpeed * 0.5 > $820877bea407f5fe$var$canvasWidth - $820877bea407f5fe$var$characterWidth ? $820877bea407f5fe$var$canvasWidth - $820877bea407f5fe$var$characterWidth : currentX + ghostSpeed * 0.5;
        return currentX - ghostSpeed;
    }
};
const $820877bea407f5fe$export$f378450f03927001 = (numberOfDots, dotWidth, magicIndex)=>Array(numberOfDots).fill(0).map((_, i)=>({
            x: i * dotWidth * 3 + dotWidth * 1.5,
            magic: i === magicIndex,
            eaten: false
        }));
const $820877bea407f5fe$export$25f1c60447c3b86f = (currentDots, playerX, randomValue)=>{
    const magicIndex = Math.floor(randomValue * $820877bea407f5fe$export$276ccf0fd889e42);
    if (currentDots.every((dot)=>dot.eaten)) return $820877bea407f5fe$export$f378450f03927001($820877bea407f5fe$export$276ccf0fd889e42, $820877bea407f5fe$export$8d09caa4156ca8c8, magicIndex);
    return currentDots.map((dot)=>{
        if ($820877bea407f5fe$export$5efe44c485c74673(dot.x, playerX, $820877bea407f5fe$export$8d09caa4156ca8c8, $820877bea407f5fe$var$characterWidth)) return {
            ...dot,
            eaten: true
        };
        else return dot;
    });
};
const $820877bea407f5fe$export$a4179c7d2afc6223 = (playerX, ghostX, dots, isMagicOn, isBlinking, score)=>{
    return {
        playerX: playerX,
        ghostX: ghostX,
        dots: dots,
        isMagicOn: isMagicOn,
        isBlinking: isBlinking,
        score: score
    };
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};





function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $25237a26c7d2a6e0$export$e19cd5f9376f8cee = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $8343668acd7c4a9b$export$f55210826850c514));



var $7031d5c115ea3033$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $7031d5c115ea3033$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $d97bc7fc19653fdc$export$b5369ffd7cb2211b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $7031d5c115ea3033$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $25237a26c7d2a6e0$export$e19cd5f9376f8cee));




var $56df0f62c44e3b4a$export$a01aa5c744e19a32 = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = $56df0f62c44e3b4a$export$a01aa5c744e19a32.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $56df0f62c44e3b4a$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $56df0f62c44e3b4a$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    delegate: undefined
};


var $1f191f1801316cb5$export$20b61f85ef6e6915 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, $56df0f62c44e3b4a$export$a01aa5c744e19a32).requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, $56df0f62c44e3b4a$export$a01aa5c744e19a32).cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, $d97bc7fc19653fdc$export$b5369ffd7cb2211b));




var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $35afd13d3a3f6ae1$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $94bcb2181a19339b$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $5aa4ef89729a15e9$export$4114a3ec92faa3c6 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $35afd13d3a3f6ae1$export$d3e54bb8584cda7c));


var $a027649630459ce7$export$5ac76215a6c70aaa = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, $5aa4ef89729a15e9$export$4114a3ec92faa3c6));


var $667fa362029613b6$export$4dc84b80a0d0c8da = new (0, $a027649630459ce7$export$5ac76215a6c70aaa)((0, $1f191f1801316cb5$export$20b61f85ef6e6915));
var $667fa362029613b6$export$1402cba6a733f33a = $667fa362029613b6$export$4dc84b80a0d0c8da;



function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}






var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};


function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $949f1fd33ffd44b7$export$8f9d79d42bff1aac() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}



function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}




function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}


function $10298329f6a978e7$export$fc00ee57782020aa(timestampProvider) {
    if (timestampProvider === void 0) timestampProvider = (0, $94bcb2181a19339b$export$c1895ea2d519a677);
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(value) {
        return {
            value: value,
            timestamp: timestampProvider.now()
        };
    });
}



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}




var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $5c96a02c592fcff1$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $5c96a02c592fcff1$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}




function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}




var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === "number" ? args.pop() : defaultValue;
}






function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}


function $75c08a98094ca84a$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var concurrent = (0, $3b29c258456d9a89$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(sources[0]) : (0, $4707859e785b3da6$export$18aef43295bbe906)(concurrent)((0, $2fe2b696577919a5$export$6788812c4e6611e6)(sources, scheduler));
}





function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(notifier).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $528e75db69787807$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}




function $2fbcbd7f7704e649$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}




var $2b2c2daf44a1044e$export$8d6b71a2b178fc32 = new (0, $5aa4ef89729a15e9$export$4114a3ec92faa3c6)((0, $d97bc7fc19653fdc$export$b5369ffd7cb2211b));
var $2b2c2daf44a1044e$export$12af436354f1a4f7 = $2b2c2daf44a1044e$export$8d6b71a2b178fc32;



function $3f3032e6ea410a39$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $bce9e90ba9895d75$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $cd8e5ea142a386bd$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $3f3032e6ea410a39$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}







var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);




function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}









var $e6cd63efe08c02de$var$isArray = Array.isArray;
function $e6cd63efe08c02de$var$callOrApply(fn, args) {
    return $e6cd63efe08c02de$var$isArray(args) ? fn.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args))) : fn(args);
}
function $e6cd63efe08c02de$export$559affaa48f4288d(fn) {
    return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(args) {
        return $e6cd63efe08c02de$var$callOrApply(fn, args);
    });
}


var $f65a851e0b190f66$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $f65a851e0b190f66$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $f65a851e0b190f66$var$jqueryMethods = [
    "on",
    "off"
];
function $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $f65a851e0b190f66$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $5c96a02c592fcff1$export$8d051b38c9118094)($f65a851e0b190f66$var$isEventTarget(target) ? $f65a851e0b190f66$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) ? $f65a851e0b190f66$var$nodeEventEmitterMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) ? $f65a851e0b190f66$var$jqueryMethods.map($f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(target)) return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $f65a851e0b190f66$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $f65a851e0b190f66$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $f65a851e0b190f66$var$isNodeStyleEventEmitter(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.addListener) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.removeListener);
}
function $f65a851e0b190f66$var$isJQueryStyleEventEmitter(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.on) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.off);
}
function $f65a851e0b190f66$var$isEventTarget(target) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.addEventListener) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(target.removeEventListener);
}



function $195e3b3043565ec4$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    return (0, $2fe2b696577919a5$export$6788812c4e6611e6)(args, scheduler);
}



function $9a6748dbc5108e5c$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $2b2c2daf44a1044e$export$8d6b71a2b178fc32);
    if (period < 0) period = 0;
    return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(period, period, scheduler);
}


var $93f4d2c1cc93ee63$var$isArray = Array.isArray;
var $93f4d2c1cc93ee63$var$getPrototypeOf = Object.getPrototypeOf, $93f4d2c1cc93ee63$var$objectProto = Object.prototype, $93f4d2c1cc93ee63$var$getKeys = Object.keys;
function $93f4d2c1cc93ee63$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($93f4d2c1cc93ee63$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($93f4d2c1cc93ee63$var$isPOJO(first_1)) {
            var keys = $93f4d2c1cc93ee63$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $93f4d2c1cc93ee63$var$isPOJO(obj) {
    return obj && typeof obj === "object" && $93f4d2c1cc93ee63$var$getPrototypeOf(obj) === $93f4d2c1cc93ee63$var$objectProto;
}






function $00d6f9870244ce2a$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $0e8b72f41887b114$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var resultSelector = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(args);
    var _a = (0, $93f4d2c1cc93ee63$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $2fe2b696577919a5$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $4f562137a990678a$export$77cea355fa80b5f4)($0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $00d6f9870244ce2a$export$79c7e160a7743efd)(keys, values);
    } : (0, $7569c528cdd9d182$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $e6cd63efe08c02de$export$559affaa48f4288d)(resultSelector)) : result;
}
function $0e8b72f41887b114$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    return function(subscriber) {
        $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $0e8b72f41887b114$var$maybeSchedule(scheduler, function() {
                    var source = (0, $2fe2b696577919a5$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $0e8b72f41887b114$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}



function $35711d117487b96b$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}


function $095ac41f805f8ce2$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)((0, $35711d117487b96b$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, true));
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});






function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}








function $ada720f14bd5f844$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $3b29c258456d9a89$export$9ae19b645239a61b)(inputs);
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $7569c528cdd9d182$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $528e75db69787807$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
                    value
                ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}


const $530a9f39b70d81fc$export$5fc51e445ce24faf = ()=>{
    return (boolO)=>boolO.pipe((0, $949f1fd33ffd44b7$export$8f9d79d42bff1aac)(), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([pv, v])=>pv === false && v === true), (0, $10298329f6a978e7$export$fc00ee57782020aa)(), (0, $9853a79d111e4e33$export$871de8747c9eaa88)((e)=>e.timestamp));
};
const $530a9f39b70d81fc$export$8987e38cfd004b13 = (startingBehavior, switcherEvent)=>{
    return (0, $75c08a98094ca84a$export$4950aa0f605343fb)(startingBehavior.pipe((0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(switcherEvent)), switcherEvent.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((newBehavior)=>newBehavior)));
};
const $530a9f39b70d81fc$export$d2de3aaeafa91619 = (time, value)=>{
    return (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(time).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((_)=>value));
};


// every paintable frame. ~60 fps
const $35da740d59af89ba$var$tick = (0, $9a6748dbc5108e5c$export$3174cdbf0a0cbc84)(0, (0, $667fa362029613b6$export$4dc84b80a0d0c8da)).pipe((0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// a stream of randomness
const $35da740d59af89ba$var$randomValue = (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(Math.random()), (0, $9a6748dbc5108e5c$export$3174cdbf0a0cbc84)(1000).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>Math.random())));
// space presses
const $35da740d59af89ba$var$spacebuttonDown = (0, $f65a851e0b190f66$export$a36e16046ae8f1bb)(document, "keydown").pipe((0, $98aaadcfa91e6727$export$3dea766d36a8935f)((event)=>event.code === "Space"));
// the direction of pacman
const $35da740d59af89ba$var$isMovingRight = (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(true), $35da740d59af89ba$var$spacebuttonDown.pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)((curr)=>!curr, true)));
// the speed of the characters,
// which later can be modified
// so it changes under certain conditions
const $35da740d59af89ba$var$playerSpeed = (0, $195e3b3043565ec4$export$ba255e9e49e00608)(4);
const $35da740d59af89ba$var$ghostSpeed = (0, $195e3b3043565ec4$export$ba255e9e49e00608)(4.4);
// the position of the player
const $35da740d59af89ba$var$playerXPosition = $35da740d59af89ba$var$tick.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)($35da740d59af89ba$var$isMovingRight, $35da740d59af89ba$var$playerSpeed), (0, $095ac41f805f8ce2$export$c87d910e63d22ed6)((x, [_, ...values])=>{
    return (0, $820877bea407f5fe$export$400968b3f7ddc0a8)(x, ...values);
}, 10), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// the state of the dots
const $35da740d59af89ba$var$dots = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
    $35da740d59af89ba$var$playerXPosition,
    $35da740d59af89ba$var$randomValue
]).pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)((dots, values)=>(0, $820877bea407f5fe$export$25f1c60447c3b86f)(dots, ...values), (0, $820877bea407f5fe$export$f378450f03927001)((0, $820877bea407f5fe$export$276ccf0fd889e42), (0, $820877bea407f5fe$export$8d09caa4156ca8c8), 12)), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// an event which fires when a dot has been eaten
const $35da740d59af89ba$var$dotEaten = $35da740d59af89ba$var$dots.pipe((0, $949f1fd33ffd44b7$export$8f9d79d42bff1aac)(), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([prev, curr])=>prev.reduce((sum, d)=>d.eaten ? sum + 1 : sum, 0) !== curr.reduce((sum, d)=>d.eaten ? sum + 1 : sum, 0)), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>1), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// an observable which emits true
// after a magic dot has been eaten,
// and switches to false after 2.3 second
const $35da740d59af89ba$var$isMagicOn = (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(false), $35da740d59af89ba$var$dotEaten.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)($35da740d59af89ba$var$dots), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([_, dots])=>dots.some((dot)=>dot.magic && dot.eaten)), (0, $530a9f39b70d81fc$export$5fc51e445ce24faf)(), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>(0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(true), (0, $530a9f39b70d81fc$export$d2de3aaeafa91619)(2300, false))), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)()));
// an observable, switching from true to false
// every 100 ms, 500 ms before the end of the magic phase
const $35da740d59af89ba$var$isBlinking = (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(false), $35da740d59af89ba$var$isMagicOn.pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)((magic)=>{
    if (magic) return (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(false), (0, $bce9e90ba9895d75$export$9dc4ecf953986f04)(1800).pipe((0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>(0, $9a6748dbc5108e5c$export$3174cdbf0a0cbc84)(100).pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((x)=>x % 2 === 0)))));
    else return (0, $195e3b3043565ec4$export$ba255e9e49e00608)(false);
}), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)()));
// the position of the ghost
const $35da740d59af89ba$var$ghostXPosition = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
    $35da740d59af89ba$var$playerXPosition,
    $35da740d59af89ba$var$isMagicOn,
    $35da740d59af89ba$var$ghostSpeed,
    $35da740d59af89ba$var$randomValue
]).pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)((x, values)=>(0, $820877bea407f5fe$export$5eb9f060287f3708)(x, ...values), 750), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// an event which fires when
// pacman is touching the ghost
const $35da740d59af89ba$var$isTouching = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
    $35da740d59af89ba$var$playerXPosition,
    $35da740d59af89ba$var$ghostXPosition
], (0, $820877bea407f5fe$export$5efe44c485c74673)).pipe((0, $530a9f39b70d81fc$export$5fc51e445ce24faf)());
// an event which fires when
// pacman is touching the ghost
// AND the magic was on
const $35da740d59af89ba$var$ghostEaten = $35da740d59af89ba$var$isTouching.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)($35da740d59af89ba$var$isMagicOn), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([x, y])=>x && y), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(()=>10));
// the current score
const $35da740d59af89ba$var$score = (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)(0), $35da740d59af89ba$var$dotEaten, $35da740d59af89ba$var$ghostEaten).pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)((sum, point)=>sum + point, 0), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
// an event which fires when
// pacman is touching the ghost
// AND the magic was not on
const $35da740d59af89ba$var$gameOver = $35da740d59af89ba$var$isTouching.pipe((0, $ada720f14bd5f844$export$d449030e5c10edf7)($35da740d59af89ba$var$isMagicOn, $35da740d59af89ba$var$score), (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(([_touch, magic, _score])=>!magic), (0, $9853a79d111e4e33$export$871de8747c9eaa88)(([_touch, _magic, score])=>score), (0, $b9a90ca4d933af63$export$43128fadae87b74a)());
// the latest state of the game
const $35da740d59af89ba$var$gameState = (0, $0e8b72f41887b114$export$77fa7d86f5204e8a)([
    $35da740d59af89ba$var$playerXPosition,
    $35da740d59af89ba$var$ghostXPosition,
    $35da740d59af89ba$var$dots,
    $35da740d59af89ba$var$isMagicOn,
    $35da740d59af89ba$var$isBlinking,
    $35da740d59af89ba$var$score
], (0, $820877bea407f5fe$export$a4179c7d2afc6223));
// a function, creating the state of the
// game over screen from the score
const $35da740d59af89ba$var$createGameOverState = (score)=>{
    return (0, $75c08a98094ca84a$export$4950aa0f605343fb)((0, $195e3b3043565ec4$export$ba255e9e49e00608)({
        isGameOver: true,
        text: `Game Over`,
        score: score
    }), $35da740d59af89ba$var$spacebuttonDown.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)(), (0, $2fbcbd7f7704e649$export$9f6ea8e48bc26eab)(()=>$35da740d59af89ba$var$gameloop)));
};
const $35da740d59af89ba$var$gameloop = (0, $530a9f39b70d81fc$export$8987e38cfd004b13)($35da740d59af89ba$var$gameState, $35da740d59af89ba$var$gameOver.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)($35da740d59af89ba$var$createGameOverState)));
$35da740d59af89ba$var$gameloop.subscribe((0, $820877bea407f5fe$export$e529deb2bfd496dc));


//# sourceMappingURL=index.4c9f9518.js.map
